import React, { Fragment } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

import Layout from './Layout'

const App = () => {
  return (
    <Fragment>
      <ToastContainer autoClose={3000} />
      <Router>
        <Layout />
      </Router>
    </Fragment>
  )
}

export default App
